type TValidatorFn = (value: string) => Promise<string>

export const checkIfValueNotEmpty =
  (checkFn: TValidatorFn, needTrim: boolean = true) =>
  (value: string) => {
    const safeValue = value || ''
    const valueToCheck = needTrim ? safeValue.trim() : safeValue
    if (valueToCheck.length) {
      return checkFn(valueToCheck)
    }

    return Promise.resolve('')
  }
